import {
  useEffect,
  useState,
} from "react";


import {
  useAuth,
} from "./auth/AuthContext";


import Login from "./pages/Login/Login";


import MainLayout from "./layouts/MainLayout/MainLayout";


import Funcionarios from "./modules/funcionarios/Funcionarios";


import Financeiro from "./modules/financeiro/Financeiro";


import Dashboard from "./modules/dashboard/Dashboard";


import Comandas from "./modules/comandas/Comandas";


import Estoque from "./modules/estoque/Estoque";


import Quadras from "./modules/quadras/Quadras";


import Clientes from "./modules/clientes/Clientes";


import Turmas from "./modules/turmas/Turmas";


import MobileNav from "./mobile/MobileNav";


import "./App.css";
import "./mobile/mobile.css";



export type Page =
  | "dashboard"
  | "comandas"
  | "estoque"
  | "quadras"
  | "turmas"
  | "clientes"
  | "financeiro"
  | "funcionarios";



function LoadingScreen() {
  return (
    <div
      style={{
        minHeight:
          "100vh",

        display:
          "grid",

        placeItems:
          "center",

        background:
          "var(--bg)",

        color:
          "var(--text-secondary)",
      }}
    >
      Carregando SUNSET ONE...
    </div>
  );
}



export default function App() {
  const {
    session,
    profile,
    loading,
    can,
  } =
    useAuth();



  const [
    page,
    setPage,
  ] =
    useState<Page>(
      "dashboard",
    );



  function canViewPage(
    target:
      Page,
  ) {
    switch (target) {
      case "dashboard":
        return can(
          "dashboard.view",
        );


      case "financeiro":
        return can(
          "financeiro.view",
        );


      case "comandas":
        return can(
          "comandas.view",
        );


      case "estoque":
        return can(
          "estoque.view",
        );


      case "quadras":
        return can(
          "quadras.view",
        );


      case "turmas":
        return can(
          "turmas.view",
        );


      case "clientes":
        return can(
          "clientes.view",
        );


      case "funcionarios":
        return can(
          "funcionarios.view",
        );


      default:
        return false;
    }
  }



  function firstAllowedPage():
    Page {
    const priority:
      Page[] = [
        "dashboard",
        "comandas",
        "quadras",
        "turmas",
        "clientes",
        "estoque",
        "financeiro",
        "funcionarios",
      ];



    return (
      priority.find(
        (
          target,
        ) =>
          canViewPage(
            target,
          ),
      ) ??
      "dashboard"
    );
  }



  useEffect(
    () => {
      if (
        loading ||
        !session ||
        !profile
      ) {
        return;
      }



      if (
        !canViewPage(
          page,
        )
      ) {
        setPage(
          firstAllowedPage(),
        );
      }
    },
    [
      loading,
      session,
      profile,
      page,
    ],
  );



  if (loading) {
    return (
      <LoadingScreen />
    );
  }



  if (
    !session ||
    !profile
  ) {
    return (
      <Login />
    );
  }



  function navigateTo(
    target:
      Page,
  ) {
    if (
      canViewPage(
        target,
      )
    ) {
      setPage(
        target,
      );


      return;
    }



    setPage(
      firstAllowedPage(),
    );
  }



  function renderPage() {
    if (
      !canViewPage(
        page,
      )
    ) {
      return null;
    }



    switch (page) {
      case "financeiro":
        return (
          <Financeiro />
        );


      case "comandas":
        return (
          <Comandas />
        );


      case "estoque":
        return (
          <Estoque />
        );


      case "quadras":
        return (
          <Quadras />
        );


      case "turmas":
        return (
          <Turmas />
        );


      case "clientes":
        return (
          <Clientes />
        );


      case "funcionarios":
        return (
          <Funcionarios />
        );


      case "dashboard":
      default:
        return (
          <Dashboard
            onNavigate={
              navigateTo
            }
          />
        );
    }
  }



  function navigationClass(
    target:
      Page,
  ) {
    return page ===
      target
      ? "app-navigation-button active"
      : "app-navigation-button";
  }



  return (
    <MainLayout>
      <nav
        className="app-navigation"
        aria-label="Navegação principal"
      >
        {can(
          "dashboard.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "dashboard",
              )
            }
            onClick={() =>
              navigateTo(
                "dashboard",
              )
            }
          >
            Início
          </button>
        )}



        {can(
          "financeiro.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "financeiro",
              )
            }
            onClick={() =>
              navigateTo(
                "financeiro",
              )
            }
          >
            Financeiro
          </button>
        )}



        {can(
          "comandas.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "comandas",
              )
            }
            onClick={() =>
              navigateTo(
                "comandas",
              )
            }
          >
            Comandas
          </button>
        )}


        {can(
          "estoque.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "estoque",
              )
            }
            onClick={() =>
              navigateTo(
                "estoque",
              )
            }
          >
            Estoque
          </button>
        )}



        {can(
          "quadras.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "quadras",
              )
            }
            onClick={() =>
              navigateTo(
                "quadras",
              )
            }
          >
            Quadras
          </button>
        )}



        {can(
          "turmas.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "turmas",
              )
            }
            onClick={() =>
              navigateTo(
                "turmas",
              )
            }
          >
            Aulas
          </button>
        )}



        {can(
          "clientes.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "clientes",
              )
            }
            onClick={() =>
              navigateTo(
                "clientes",
              )
            }
          >
            Clientes
          </button>
        )}



        {can(
          "funcionarios.view",
        ) && (
          <button
            type="button"
            className={
              navigationClass(
                "funcionarios",
              )
            }
            onClick={() =>
              navigateTo(
                "funcionarios",
              )
            }
          >
            Funcionários
          </button>
        )}
      </nav>



      {renderPage()}



      <MobileNav
        page={
          page
        }
        onNavigate={
          navigateTo
        }
      />
    </MainLayout>
  );
}